import {formBodyType} from '../../util/uiconstants';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {uniqBy, isEmpty, sum} from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function independenceReducer(state = initialState.independenceSummary, action) {
	switch (action.type) {
		case types.GET_INDEPENDENCE_SUMMARY: {
			if (!isEmpty(action.response)) {
				var questions = [];

				// taking all the questions without
				questions = uniqBy(
					action.response.map((item) => {
						return {
							knowledgeFormBodyId: item.formBodies[0].knowledgeFormBodyId,
							formBodyTypeId: item.formBodies[0].formBodyTypeId,
							formBodyDescription: item.formBodies[0].formBodyDescription,
							knowledgeDisplayOrder: item.formBodies[0].knowledgeDisplayOrder,
							bodyFreeText: item.formBodies[0].bodyFreeText,
							documentId: item.formBodies[0].documentId
						};
					}),
					'knowledgeFormBodyId'
				);

				//for each question we add the possible options
				questions.forEach((item) => {
					//filtering to avoid adding options to the free text questions
					let replies = action.response
						.filter((reply) =>
							reply.formBodies.some(
								(res) => res.knowledgeFormBodyId === item.knowledgeFormBodyId && isEmpty(item.bodyFreeText)
							)
						)
						.map((res) => {
							return {
								knowledgeFormBodyOptionId: res.formBodies[0].knowledgeFormBodyOptionId,
								formBodyOptionText: res.formBodies[0].formBodyOptionText,
								actionTypeId: res.formBodies[0].actionTypeId,
								userCount: res.userCount
							};
						});

					//if we have replies they are added to the replies object with the total count for all replies
					if (!isEmpty(replies)) {
						item.formBodyOptions = replies;
						item.totalUsers = sum(replies.map((item) => item.userCount));
					}
				});

				return questions;
			} else {
				return [{isEmpty: true}]
			}
		}
		default:
			return state;
	}
}

export function independenceResponsesReducer(state = initialState.independenceResponses, action) {
	switch (action.type) {
		case types.GET_INDEPENDENCE_RESPONSES: {
			let responses = [...action.response.responses];
			for (let i = 0; i < responses.length; i++) {
				const element = responses[i];
				responses[i].fullName = element.firstName + ' ' + element.lastName;
			}
			responses = responses.sort(sortFullName);

			return responses;
		}
		default:
			return state;
	}
}

export function independenceValidationsReducer(state = initialState.independenceValidations, action) {
	switch (action.type) {
		case types.GET_INDEPENDENCE_VALIDATIONS: {
			let validations = [];
			if (action.response) {
				action.response.map((validationType) => {
					if (validationType.children.length > 0) {
						validationType.children.map((item) => {
							validations.push({
								userId: item.validationId.toLowerCase(),
								validationTypeId: item.validationTypeId,
								validationCount: item.validationCount
							});
						});
					}
				});
			}

			return validations;
		}
		default:
			return state;
	}
}

const sortFullName = (a, b) => {
	if (a.fullName < b.fullName) {
		return -1;
	}
	if (a.fullName > b.fullName) {
		return 1;
	}
	return 0;
};

const sortKnowledgeOrder = (a, b) => {
	if (a.knowledgeFormBodyId < b.knowledgeFormBodyId) {
		return -1;
	}
	if (a.knowledgeFormBodyId > b.knowledgeFormBodyId) {
		return 1;
	}
	return 0;
};
